import {
  curry
} from 'lodash/curry'
import {
  fork,
  call,
  put,
  take,
  takeEvery
} from 'redux-saga/effects'

import {
  CREATE_ASYNC_LISTENER
} from './constants'
import {
  decrementAsyncFilter,
  incrementAsyncFilter,
} from './actions'

function* asyncHandler(action) {
  const { actionName, incrementActions, decrementActions } = action
  yield take(incrementActions)
  yield put(incrementAsyncFilter(actionName))
  yield take(decrementActions)
  yield put(decrementAsyncFilter(actionName))
}

function* watchAsync() {
  yield takeEvery(CREATE_ASYNC_LISTENER, asyncHandler)
}

export {
  watchAsync,
}
